<template>
  <div>
    <!-- <div class="member_tabbar">
      <a href="javascript:;" :class="{'active': curTitle == 1}" @click="changeTitle(1)">学习记录<i></i></a>
      <a href="javascript:;" :class="{'active': curTitle == 2}" @click="changeTitle(2)">我的收藏<i></i></a>
    </div> -->
    <accnav
      :list="navList"
      :curTitleId="curTitleId"
      @titleChange="titleChange"
    ></accnav>
    <div>
      <component :is="child"></component>
    </div>
  </div>
</template>

<script>
import {ApiGetTaskList} from '../../net/accound/index.js'
import accnav from '../../common/accnav.vue'
import news from './children/news.vue'
import feedback from './children/feedback.vue'
import service from './children/service.vue'
export default {
  data: function () {
    return {
      curTitleId: 1, //  1 我的消息   2 客服中心  3意见反馈
      navList: [{
        id: 1,
        name: '我的消息',
      },{ 
        id: 2,
        name: '客服中心',
      },{
        id: 3,
        name: '意见反馈',
      }],
      loading: false,
    }
  },
  computed: {
    child: function () {
      switch (this.curTitleId) {
        case 1:
         return news
         break
        case 2:
         return service
         break
        case 3:
         return feedback
         break
      }
    }
  },
  components:{accnav},
  methods:{
    titleChange: function (id) {
      this.curTitleId = id
    }
  },
  mounted: function () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AccMyTool/AccMyTool.vue